import { render, staticRenderFns } from "./PersonalContactTab.vue?vue&type=template&id=18a5f358"
import script from "./PersonalContactTab.vue?vue&type=script&lang=ts"
export * from "./PersonalContactTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports